var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',{style:({
    width: _vm.width ? _vm.width + 'px' : undefined,
    height: _vm.height ? _vm.height + 'px' : undefined,
  }),attrs:{"src":_vm.devImgs[_vm.name],"preview-src-list":[_vm.devImgs[_vm.name]]}})
}
var staticRenderFns = []

export { render, staticRenderFns }